var __jsx = React.createElement;
import { styled } from '@linaria/react';
import React from 'react';
import { gray4 } from '@engage/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Asset = function Asset(_ref) {
  var fill = _ref.fill;
  var style = React.useMemo(function () {
    return {
      fill: fill
    };
  }, [fill]);
  return /*#__PURE__*/_jsxs("svg", {
    "aria-labelledby": "loading-spinner",
    viewBox: "0 0 8.76708 8.76708",
    style: style,
    children: [/*#__PURE__*/_jsx("g", {
      id: "aa6c51cc-17be-4bb2-b590-eff848918ade",
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.0195.71838a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "e30a7df2-494f-413c-83ce-9c086a0f5b03",
      children: /*#__PURE__*/_jsx("path", {
        d: "M1.66357,1.57586a.364.364,0,1,1,.36405.36405.364.364,0,0,1-.36405-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "ed31ebfb-e32c-4943-b2f3-f7a06945e78c",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.41,3.74709a.364.364,0,1,1,.36405.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "f1e3d482-57d3-47fb-a22d-fd646c937057",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.84537,6.21612a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "f34b4db2-64f0-4c09-8cb5-8681a8367865",
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.76594,7.82767a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "abce6047-30aa-4fa0-a060-a16359b5f515",
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.27306,7.82767a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "b3fcab82-4224-4a47-9539-524f13e5b18f",
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.19362,6.21612a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "b828ae42-b974-478f-9703-a0b4055cc1ab",
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.629,3.74709a.364.364,0,1,1,.364.364.364.364,0,0,1-.364-.364Z"
      })
    }), /*#__PURE__*/_jsx("g", {
      id: "bf002f8b-2168-48c5-94c2-45aa56f84721",
      children: /*#__PURE__*/_jsx("path", {
        d: "M6.37542,1.57586a.364.364,0,1,1,.364.36405.364.364,0,0,1-.364-.364Z"
      })
    })]
  });
};

export var BaseSpinner = /*#__PURE__*/styled("div")({
  name: "BaseSpinner",
  class: "b1mlvox1"
});
export var Spinner = function Spinner(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? gray4 : _ref2$fill;
  return /*#__PURE__*/_jsx(BaseSpinner, {
    className: className,
    children: /*#__PURE__*/_jsx(Asset, {
      fill: fill
    })
  });
};
export var LargeSpinner = /*#__PURE__*/styled(Spinner)({
  name: "LargeSpinner",
  class: "lnp1kit"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/shared-ui/Spinner.linaria.module.css");